
import { IEvent } from "@quest/adapter-interface";
import { clone, Container, detectDeviceEnvironmentConstants, dispatcher, ingenuity, ISpineData, SpineBase } from "@quest/base-core";
import { BaseViewBehavior, MeterBehavior, SlotConstantsBehavior, SlotEventConstantsBehavior } from "@quest/murka-games-behavior-panther";
import { HoldAndRespinReelPanelController } from "../ReelPanel/HoldAndRespinReelPanelController";
import { gameConstants } from "../../Constants/gameConstants";


export class HoldAndRespinView extends BaseViewBehavior {
  private reelView: HoldAndRespinReelPanelController;
  constructor(json: any) {
    super(json);
    this.visible = true;
    ingenuity.deviceEnv.isDesktop && (this.getImageById("reelBG").mask = this.getShapeById("reelMask"));

  }
  /**
   * resize as per basegame
   */
  public resize(e: IEvent) {
    super.resize(e);
    if (ingenuity.deviceEnv.getOrientation() === detectDeviceEnvironmentConstants.constants.ORIENTATION.PORTRAIT) {
      this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
      this.scale.set(ingenuity.deviceEnv.getPortraitMaxReelScale());
      this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER) + (gameConstants.PORTRAIT_SHIFT_X * this.scale.x);
      this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + SlotConstantsBehavior.ADD_IN_Y;
    }
    else {
      this.pivot.set(ingenuity.configData.width * SlotConstantsBehavior.HALF_CONVERTER, ingenuity.configData.height * SlotConstantsBehavior.HALF_CONVERTER);
      this.scale.set(ingenuity.deviceEnv.getLandcapeMaxReelScale());
      this.x = (innerWidth * SlotConstantsBehavior.HALF_CONVERTER) + (SlotConstantsBehavior.REEL_SIDE_SPACE * this.scale.x);
      if (ingenuity.deviceEnv.isDesktop) {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((SlotConstantsBehavior.REEL_BOTTOM_SPACE / 2) * this.scale.x);
      }
      else {
        this.y = (innerHeight * SlotConstantsBehavior.HALF_CONVERTER) + ((SlotConstantsBehavior.REEL_BOTTOM_SPACE_LANDSCAPE / 2) * this.scale.x);
      }
    }
    dispatcher.fireEvent(SlotEventConstantsBehavior.ADD_BUTTON_PANEL_ON_TOP);
  }
  /**Set reel view for prize spin view */
  public setReelView(reelView: HoldAndRespinReelPanelController, pos?: number, parentId?: string): void {
    this.reelView = reelView
    this.addChildAt(reelView, 1);
  }
  /**
   * @returns reel view
   */
  public getReelView(): HoldAndRespinReelPanelController {
    return this.reelView
  }

  public createSpineAnimation(name: string): SpineBase {
    const spineJSON: ISpineData = clone(this.json[name]);
    spineJSON.type = "spine"
    const spine: SpineBase = this.createSpine(spineJSON);
    spine.visible = true;
    return spine;

  }
  public createContainerClone(name: string, id?: string): Container {
    const containerJSON: any = clone(this.json[name]);
    containerJSON.type = "container"
    id && (containerJSON.id = id)
    const container: Container = this.createContainer(containerJSON);
    container.visible = true;
    return container;

  }
  /**
 * to clone Meter Bitmap Text of initial symbols
 */
  public createMeterClone(name: string): MeterBehavior {
    let bitmapMeterObject: any = clone(this.json[name]);
    bitmapMeterObject.type = "meter";
    let bitmapMeterTextClone: MeterBehavior = this.createMeter(bitmapMeterObject) as MeterBehavior;
    bitmapMeterTextClone.visible = true;
    return bitmapMeterTextClone;
  }
  /**
   * to reset view
   */
  public resetRespinView(): void {
    this.reelView = null;
    this.visible = false;
    this.destroy();
  }
}